var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWithdraw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_withdraw") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u5207\\u7247",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u753B\\u677F",
    transform: "translate(-140, -80)",
    stroke: "#0E1C39",
    strokeWidth: 1.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-10",
    transform: "translate(139, 87)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6565186,0.530672729 L7.92808461,2.62588269 C7.60318189,2.7038737 7.40302041,3.03048361 7.48101142,3.35538633 C7.50950106,3.47407129 7.57322286,3.58136372 7.66380677,3.66317041 L8.13915106,4.09245573 C8.86566009,4.74856894 8.98265945,5.84602559 8.41080297,6.64055695 C5.23050969,11.0592162 4.71566203,15.5338167 6.86625681,20.0643562 C7.43591554,16.1268151 9.59347338,12.3909336 13.3389303,8.85671164 L15.2715938,10.9340095 C15.4991911,11.1786395 15.882007,11.1924472 16.126637,10.9648499 C16.2320877,10.8667413 16.2990776,10.7342303 16.3155607,10.5911448 L17.398759,1.18819789 C17.4369974,0.856260849 17.1989076,0.55617436 16.8669706,0.517935961 C16.7966152,0.509831174 16.7253831,0.514142212 16.6565186,0.530672729 Z",
    id: "\\u8DEF\\u5F84",
    transform: "translate(11.5313, 10.1965) scale(1, -1) rotate(-59) translate(-11.5313, -10.1965)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.531006,0.710898745 L33.5422984,0.710898745 C34.210563,0.710898745 34.7522984,1.2526342 34.7522984,1.92089875 C34.7522984,1.98003467 34.7479632,2.03909104 34.7393277,2.09759306 L32.8667221,14.7837043 C32.2533839,18.9388112 28.6876477,22.0168441 24.4875171,22.0168441 L9.95139307,22.0168441 L9.95139307,22.0168441",
    id: "\\u8DEF\\u5F84-3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 27.7387624,
    y1: 7.74531676,
    x2: 20.1195635,
    y2: 7.74531676,
    id: "\\u8DEF\\u5F84-4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWithdraw);
export default __webpack_public_path__ + "static/media/icon_withdraw.00231afb8f5d9f1085ff2ab3e4a52778.svg";
export { ForwardRef as ReactComponent };